export default __webpack_public_path__ + "static/media/site-logo.c9e874d5.png";